import clsx from 'clsx';
import React from 'react';
import Button from '../Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';

interface InvestigationReportingDeleteQuestionModalProps {
  otherClasses?: string;
  handleClose: () => void;
  question: any;
  handleDeleteQuestion: () => void;
}

const InvestigationReportingDeleteQuestionModal: React.FC<
  InvestigationReportingDeleteQuestionModalProps
> = ({ otherClasses, handleClose, question, handleDeleteQuestion }) => {
  const investigationReportingDeleteQuestionModalClasses = clsx(otherClasses);

  const lg = useButtonSizeLarge();

  return (
    <div
      className={investigationReportingDeleteQuestionModalClasses}
      data-testid="investigation-reporting-delete-question-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <WarningIcon className="[&>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">Are you sure?</h4>
        <p className="text-brand-posh-pink font-nonrmal text-lg leading-5">
          Are your sure you want to remove the question:{' '}
          <strong className="font-bold">{question?.question}</strong>
        </p>
      </div>
      <div className="mt-8 flex flex-col-reverse gap-2.5 sm:grid sm:grid-cols-2 sm:gap-6 lg:mt-12">
        <Button
          otherClasses="!text-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink "
          size={lg}
          variant="secondary"
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        <Button
          otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:bg-transparent hover:border-brand-posh-pink"
          size={lg}
          onClick={() => handleDeleteQuestion()}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default InvestigationReportingDeleteQuestionModal;
